import buildConfig from './build-config.json';

// /v2/internal/ping へのリクエストは public-api-production-ip ALB に繋がるものの 404 となり、
// 結果的に papertrail のコストがかさんでしまっているので、必要が出るまで停止する
const pingAllowdTokens: string[] = [
  // '9c7cb6d2-1bbd-4569-b837-16df043c9007', // au Payマーケット: https://app.repro.io/apps/m6x0q86k/
  // 'f9b0f027-b911-4be9-ac00-4004a43abe82', // コミックシーモア: https://app.repro.io/apps/ndn5pwdz/
  // '7ab5024c-19b9-4ac1-9231-8a45b06c56d8', // TVer: https://app.repro.io/apps/r67mwn65/
  // '67cd26de-f4e6-4097-9a88-76fd29204288', // d fashion: https://app.repro.io/apps/o3ox5w34/
  // '047b2dad-abbe-4060-b5e9-6f8fd5e7c0b1', // au占い: https://app.repro.io/apps/8dq5qgdr/
];

export const sendPingRequest = (token: string): void => {
  if (!pingAllowdTokens.includes(token)) return;

  window.fetch(`${buildConfig.pingURL}?t=${token}`, {
    method: 'HEAD',
  });
};
